module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/047-dominican-republic-88bd1a72940b2638d3f731f3b706045a.svg";